import { useCallback } from 'react'
import { setAnswersAction } from 'root-redux/actions/common'
import { useDispatch } from 'react-redux'
import { IStepInfo, TAnswer } from 'models/common.model'
import { sendUserInfoAction } from 'root-redux/actions/user'
import { eventLogger } from 'services/eventLogger.service'
import { goTo } from '../browserHistory'

export const useNextStep = ({
  pageId,
  question,
  nextPagePath,
}: IStepInfo): ((value: TAnswer) => void) => {
  const dispatch = useDispatch()

  return useCallback(
    (value: TAnswer) => {
      dispatch(
        setAnswersAction({
          answers: value,
          pageId,
        }),
      )
      dispatch(sendUserInfoAction())
      eventLogger.logQuestion({ question, answers: value })

      goTo(nextPagePath)
    },
    [dispatch, question, pageId, nextPagePath],
  )
}
